import { useEffect, useRef, useState } from 'react'
import { Link, Outlet, useLocation, useRouteError } from 'react-router'
import { RefreshCw, TriangleAlert } from 'lucide-react'
import { Boton } from './Boton'
import { Cargando } from './Cargando'
import { cargaExitosa, esErrorDeCarga, navegador, recargarUnaVez } from '@/lib/recarga'
import { es } from '@/textos/es'

const t = es.errorApp

/** La ruta raíz: envuelve a todas y, cuando se abre otra pantalla, suelta la marca de recarga. */
export function Raiz() {
  const { pathname, search } = useLocation()
  useEffect(() => cargaExitosa(pathname + search), [pathname, search])
  return <Outlet />
}

/**
 * El error de cualquier ruta (#64). Si no se pudo descargar la pantalla, recarga una sola vez;
 * si ya recargó o es otro error, pinta un aviso propio en español, nunca el de React Router.
 */
export function ErrorDeRuta() {
  const error = useRouteError()
  const { pathname, search } = useLocation()
  const ruta = pathname + search
  const deCarga = esErrorDeCarga(error)
  const [decidiendo, setDecidiendo] = useState(deCarga)
  const hecho = useRef(false)

  useEffect(() => {
    if (!deCarga || hecho.current) return
    hecho.current = true
    if (!recargarUnaVez(ruta)) setDecidiendo(false)
  }, [deCarga, ruta])

  if (decidiendo) return <Cargando texto={t.recargando} />
  return (
    <main className="mx-auto flex min-h-screen max-w-lg items-center p-4 sm:p-8">
      <div
        role="alert"
        className="flex w-full flex-col items-center gap-3 rounded-tarjeta border border-alerta-bloqueo-borde bg-alerta-bloqueo-bg p-8 text-center text-alerta-bloqueo-texto"
      >
        <TriangleAlert size={28} aria-hidden />
        <h1 className="text-h2 text-alerta-bloqueo-titulo">
          {deCarga ? t.cargaTitulo : t.genericoTitulo}
        </h1>
        <p className="text-body">{deCarga ? t.cargaTexto : t.genericoTexto}</p>
        <Boton onClick={() => navegador.recargar()}>
          <RefreshCw size={16} aria-hidden />
          {t.recargar}
        </Boton>
        <Link to="/" reloadDocument className="text-small underline">
          {es.comun.irAlInicio}
        </Link>
      </div>
    </main>
  )
}
